// extracted by mini-css-extract-plugin
module.exports = {"container":"infoBox_container__1wmKE","textInfo":"infoBox_textInfo__19o-o","icn":"infoBox_icn__15kYC","artist":"infoBox_artist__1oAkV"};